import { ProductServiceType } from '@package/core/src/shoppingCart';
import clsx from 'clsx';

import ProductServiceContent from '../ProductServiceContent';
import config from 'config-base';
import styles from './Service.module.css';
import { ProductServiceProps } from './types';

const ProductService = ({
  data,
  productSku,
  className,
  contentClassName,
  addProductService,
  deleteSpecifiedService,
  deleteProductService,
}: ProductServiceProps) => (
  <div
    className={clsx(styles.serviceAddon, { [styles.serviceAddonAGD]: config.brandCode !== '0' }, className)}
    data-testid="product-service"
  >
    <ProductServiceContent
      key={`${data.seq}${productSku}`}
      title={data.name}
      services={data.elements}
      combineAllowed={data.combineAllowed}
      productSku={productSku}
      className={contentClassName}
      deleteSpecifiedService={async (sku: string)=> {
        await deleteSpecifiedService(sku);
      }}
      addProductService={async (service) => {
        await addProductService({
          serviceId: service.id,
          productSku,
          serviceType: ProductServiceType.ExpertSetup,
          product: service,
        });
      }}
      deleteProductService={async () => {
        await deleteProductService();
      }}
    />
  </div>
);

export default ProductService;
